module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 68
// module chunks = 0